var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canteen.badges[_vm.badge.key])?_c('p',[_vm._v(_vm._s(_vm.badge.subtitle))]):_c('p',[_vm._v("Cet établissement ne respecte pas encore la loi EGAlim pour cette mesure.")])])}
var staticRenderFns = []

export { render, staticRenderFns }